import { Highlight, Text } from "@chakra-ui/react"

type Props = {
  text: string
  filterValue: string
}

const FilterableText = ({ text, filterValue }: Props) => {
  return (
    <Text>
      <Highlight query={filterValue.length > 2 ? filterValue : ""} styles={{ fontWeight: "bold" }}>
        {text}
      </Highlight>
    </Text>
  )
}

export default FilterableText
